import React from 'react'
import { motion } from "framer-motion"
import service_bg from "../assets/images/services/services-2.jpg"
import { getServiceDate, getServiceData } from '../utlits/fackData/classData';
import Tp1Form from '../components/sections/tp1Form' 
import PageTitle from '../components/common/pageTitle'
import { ScrollRestoration } from 'react-router-dom'
import { zoomIn } from '../utlits/zoomIn'

const Tp1Details = () => {
  const tp1Date = getServiceDate(5); // Gets TP1 details
  const serviceData = getServiceData(5); // Gets complete service data including dates
  
  return (
    <>
      <PageTitle link={"TP1 Details"} pageName={"Tactical Pistol Class 1 Details"} />
      <div className="services-details-area pt-100 pb-75">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <motion.div className="image"
                initial="offscreen"
                whileInView="onscreen"
                variants={zoomIn(1)}
                viewport={{ once: true, amount: 0 }}
              >
                <img src={service_bg} alt="Tactical Pistol Class 1" />
              </motion.div>
            </div>
            <div className="col-lg-6">
              <h1>Tactical Pistol Class 1</h1>
              <h2>$150 | {tp1Date}</h2>
              <br />

             <h3>Woodlawn<br />
              1450 Hwy 98 E Columbia, MS 39429</h3>
              <p>Tactical Pistol 1 is a comprehensive, course designed to build a solid foundation for shooters of all experience levels, focusing on identifying and correcting common firearm mistakes and malfunctions while sharpening mindset and core weapon-handling skills. Students will work extensively on the range to improve magazine exchanges/reloads, shooting positions, and overall confidence with their handgun. While no prior training is required, enhanced concealed carry training and/or basic pistol knowledge is strongly encouraged. </p>

<p>Required gear includes:
  <ul>
    <li>handgun</li>
    <li>at least two magazines (three preferred)</li>
    <li>holster</li>
    <li>eye and ear protection</li>
    <li>300 rounds of ammunition.</li>
  </ul>
</p>
<p>Because most of the class takes place outdoors on the range, students are encouraged to bring:
<ul>
  <li>chair</li>
  <li>sunscreen</li>
  <li>bug spray</li>
  <li>water source</li>
  <li>snacks</li>
  <li>hat</li>
  <li>weather-appropriate clothing.</li>
  </ul>
</p>
              <br />
              <p>After you complete the form, you will be taken to our payment page. Your payment is required to reserve your seat immediately.
              If you have any questions or concerns please contact us at j5solutionssp@gmail.com. You can also call or text (601)633-1159.
              We look forward to training with you.</p>
            </div>
          </div>
        </div>
        <div className="services-details-area pt-100 pb-75"> 
          <Tp1Form serviceData={serviceData} />
        </div>
      </div>
      <ScrollRestoration />
    </>
  )
}

export default Tp1Details